import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { PaginateNavigate } from "components/paginateComponent/PaginateComponent";
import { useState } from "react";
import React from "react";
import { formaterDocument } from "utils/formaterDocumente";
import { UseDashboard } from "hooks/DashboardHook";
import { useQuery } from "react-query";

interface ModalVersionsProps {
  isOpen: boolean;
  onClose: () => void;
  nomeCTR: string;
  idCTR: number;
  dias: number;
  lucroReal: any;
}

export function ModalCTR(props: ModalVersionsProps) {
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "navy.900");
  const [paginate, setPaginate] = useState<number>(1);
  const { findClientsByCRT } = UseDashboard();
  const { data, isLoading, error } = useQuery(
    [findClientsByCRT, props.idCTR, props.lucroReal, paginate, props.dias],
    () =>
      findClientsByCRT({
        dias: props.dias,
        idCrt: props.idCTR,
        lucroReal: Number(props.lucroReal),
        page: paginate,
      })
  );

  return (
    <Modal
      motionPreset="slideInBottom"
      size="6xl"
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <ModalOverlay />
      <ModalContent bg={boxBg}>
        <ModalHeader>{props.nomeCTR}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {isLoading ? (
            <>
              <Box display="flex" alignItems="center" justifyContent="center">
                <Spinner
                  speed="0.65s"
                  width="100px"
                  height="100px"
                  thickness="4px"
                />
              </Box>
            </>
          ) : error ? (
            <Box color="red.500" textAlign="center">
              {String(error || "")}
            </Box>
          ) : data && data.data ? (
            <>
              <TableContainer>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>Empresa</Th>
                      <Th>CNPJ</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {data.data.map((empresa: any, idx: number) => (
                      <React.Fragment key={empresa.documento + idx}>
                        <Tr
                          color={brandColor}
                          cursor={"pointer"}
                          _hover={{
                            bg: "var(--chakra-filled-background-hover)",
                          }}
                          transition={"0.3s"}
                        >
                          <Td>{empresa.NOME}</Td>
                          <Td>{formaterDocument(empresa.DOCUMENTO)}</Td>
                        </Tr>
                      </React.Fragment>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
              <PaginateNavigate
                current_page={data?.current_page}
                pages_preview={data?.links}
                pageSelect={setPaginate}
                lastPage={data?.last_page}
              />
            </>
          ) : (
            <Box textAlign="center">Nenhum dado disponível</Box>
          )}
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="red" onClick={props.onClose}>
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
